'use strict'
import { ERROR, INFO, RESET_MODAL, SUCCESS } from '../constants/ToastrConstants'


export const store = {
	messageType: '',
	message: '',
	open: false
}

export function ToastrReducer(state = {}, action) {
	switch (action.type) {
		case RESET_MODAL: {
			return Object.assign({}, state, store)
		}
		case ERROR:
		case INFO:
		case SUCCESS: {
			return Object.assign({}, state, {
				messageType: action.type,
				message: action.message,
				open: true
			})
		}
		default:
			return state
	}
}




// WEBPACK FOOTER //
// ./src/home/reducers/ToastrReducer.js